import React, { useState, useEffect } from 'react';

// Material UI
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton'

// Components
import Spinner from '../../components/spinner';
import Totals from './totals';
import ActivePromotions from '../../components/activePromotions';

//Hooks
import useUser from "../../hooks/user/useUser";
import useNotify from "../../hooks/notify";

// Services
import billingService from '../../services/billingService';

// Utils
import { utils } from '../../utils/utils';

const Dashboard = () => {
    const { branch } = useUser();
    const { Notify, variants } = useNotify();

    const [loading, setLoading] = useState(false);
    const [totalSales, setTotalSales] = useState();

    useEffect(() => {
        if (branch?.code) {
            setLoading(true);
            billingService
                .GetTotalSummary(branch.code)
                .then(res => setTotalSales(res))
                .catch(() => Notify("No se pudo obtener las ventas del dia", variants.ERROR))
                .finally(() => setLoading(false));
        }
    }, [branch?.code, Notify, variants])

    const ticketsLabel = (count) => `${count} ${count === 1 ? 'ticket' : 'tickets'}`;

    const pctOfGross = totalSales?.amountSales
        ? (totalSales.amountVoid / totalSales.amountSales) * 100
        : 0;

    const avgTicket = totalSales?.countSales
        ? totalSales.amountSales / totalSales.countSales
        : 0;

    const netAmount = (totalSales?.amountSales || 0) - (totalSales?.amountVoid || 0);
    const netTicketsCount = (totalSales?.countSales || 0) + (totalSales?.countVoid || 0);
    const netAvgTicket = netTicketsCount ? netAmount / netTicketsCount : 0;

    return (
        <Container maxWidth="xxl">
            <Grid container spacing={2} justifyContent='center'>
                {loading &&
                    <Spinner message='Cargando' lockScreen />}
                <Grid size={12}>
                    <Grid container spacing={2} justifyContent='center'>
                        <Grid
                            size={{
                                xs: 12,
                                md: 6,
                                lg: 4
                            }}

                        >
                            {!totalSales
                                ? <Skeleton variant="rectangular" height={118} />
                                : <Totals
                                    title='Ventas facturadas'
                                    value={totalSales.amountSales}
                                    color='info'
                                    leftStat={ticketsLabel(totalSales.countSales)}
                                    rightStat={`Prom. $${utils.formatMoney(avgTicket)}`}
                                    progress={{ percent: 100, caption: '' }}
                                  />}
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                md: 6,
                                lg: 4
                            }}
                        >
                            {!totalSales
                                ? <Skeleton variant="rectangular" height={118} />
                                : <Totals
                                    title='Notas de crédito'
                                    value={totalSales.amountVoid}
                                    color='error'
                                    leftStat={ticketsLabel(totalSales.countVoid)}
                                    rightStat={`${pctOfGross.toFixed(1).replace('.', ',')}% del total`}
                                    progress={{ percent: 100, caption: '' }}
                                  />}
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                md: 6,
                                lg: 4
                            }}
                        >
                            {!totalSales
                                ? <Skeleton variant="rectangular" height={118} />
                                : <Totals
                                    title='Ventas netas'
                                    value={netAmount}
                                    color='success'
                                    leftStat={ticketsLabel(netTicketsCount)}
                                    rightStat={`Prom. $${utils.formatMoney(netAvgTicket)}`}
                                    progress={{ percent: 100, caption: '' }}
                                  />}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <ActivePromotions />
                </Grid>
            </Grid>
        </Container>
    );
}

export default Dashboard;